import { useEffect, useState, useMemo } from "react";
import { useApiContext } from 'context/ApiContext';  // Utilisation du contexte

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import 'leaflet/dist/leaflet.css';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDDatePicker from "components/MDDatePicker";
import MDTypography from "components/MDTypography";
import MDMapLeaflet from "components/MDMapLeaflet";
import MDMapLibre from "components/MDMapLibre";

// Material Dashboard 2 React example components
import TurbineDashboardLayout from "examples/LayoutContainers/DashboardLayout";
import TurbineDashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import DataTable from "examples/Tables/DataTableV2";


function MainParkList() {
    const { parksPaL, alertsNumPaL, fromDatePaL, toDatePaL, APIRequestType, getAPI, setFromDatePaL, setToDatePaL } = useApiContext();

    // Tableau de points GPS a afficher sur la carte
    const points = useMemo(() =>
        parksPaL.map(park => {
            const [lat, lng] = park.position.split(',').map(coord => parseFloat(coord.trim()));
            return {
                lat,
                lng,
                id: park.id,
                popupText: park.name,
            };
        }), [parksPaL]);

    // Declenchement a l'ouverture de la page et au changement des dates de debut et de fin
    useEffect(() => {
        console.log(" 0 0 3   PaL");
        getAPI(APIRequestType.GET_USER_PARKS);
    }, [fromDatePaL, toDatePaL]);

    const handleFromDateChange = (date) => {
        setFromDatePaL(date || null);
        if (date && toDatePaL && date > toDatePaL) {
            setToDatePaL(date);
        }
    };

    const handleToDateChange = (date) => {
        setToDatePaL(date || null);
    };

    return (
        <TurbineDashboardLayout>
            <TurbineDashboardNavbar />
            <MDBox display="flex" alignItems="center" justifyContent="space-between" gap={3} mt={1} mb={0} ml={-0.5}>
                <MDBox display="flex" alignItems="center" gap={0}>
                    {/* Date Picker "From" */}
                    <MDDatePicker
                        label="From"
                        value={fromDatePaL}
                        onChange={handleFromDateChange}
                        scale={0.9}
                    />

                    {/* Date Picker "To" */}
                    <MDDatePicker
                        label="To"
                        value={toDatePaL}
                        onChange={handleToDateChange}
                        minDate={fromDatePaL} // Empêche de choisir une date antérieure
                        scale={0.9}
                    />
                </MDBox>
            </MDBox>

            <MDBox py={2}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6} lg={3} mt={2}>
                        <MDBox mb={1.5}>
                            {alertsNumPaL > 1 && (
                                <>
                                    <ComplexStatisticsCard
                                        color="info"
                                        icon="crisis_alert"
                                        title="Detections"
                                        count={alertsNumPaL}
                                        lines={1}
                                    />
                                </>
                            )}
                            {alertsNumPaL < 2 && (
                                <>
                                    <ComplexStatisticsCard
                                        color="info"
                                        icon="crisis_alert"
                                        title="Detection"
                                        count={alertsNumPaL}
                                        lines={1}
                                    />
                                </>
                            )}
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>

            <MDBox display="flex" alignItems="center" justifyContent="center" >
                {parksPaL.length == 0 && (
                    <>
                        <MDTypography variant="button"
                            fontWeight="bold"
                            color="secondary"
                            opacity={0.4}
                            ml={1}
                            fontSize="5rem">
                            No Park
                        </MDTypography>
                    </>
                )}
            </MDBox>

            <MDBox pb={3} style={{ height: '32vh', minHeight: '250px',  width: '100%'}}>
                {parksPaL.length > 0 && (
                    <MDMapLibre mapType={"parkList"} points={points} />
                )}
            </MDBox>

            <MDBox pt={3} pb={3}>
                {parksPaL.length > 0 && (
                    <>
                        <Grid container spacing={6}>
                            <Grid item xs={12}>
                                <Card>
                                    <MDBox
                                        mx={2}
                                        mt={-3}
                                        py={1.5}
                                        px={2}
                                        variant="gradient"
                                        bgColor="info"
                                        borderRadius="lg"
                                        coloredShadow="info"
                                    >
                                        <MDTypography variant="h6" color="white">
                                            Park List
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox display="flex" justifyContent="flex-end" alignItems="flex-end" mt={1.5} mr={2.5} mb={-2.5}>
                                        <MDTypography variant="button"
                                            fontWeight="light"
                                            color="dark"
                                            ml={1}
                                            fontSize="1rem">
                                            Total Park Number :
                                        </MDTypography>
                                        <MDTypography variant="button"
                                            fontWeight="bold"
                                            color="dark"
                                            ml={1}
                                            fontSize="1rem">
                                            {parksPaL.length}
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox pt={3}>
                                        <DataTable
                                            table={{
                                                columns: [
                                                    { Header: "Park", accessor: "park", align: "left" },
                                                    { Header: "Address", accessor: "address", align: "left" },
                                                    { Header: "Detection(s)", accessor: "detection", align: "center" },
                                                    { Header: "Turbine(s)", accessor: "turbine", align: "center" },
                                                ],
                                                rows: parksPaL.map((park) => ({
                                                    parkValue: park.name,
                                                    parkidValue: park.id,
                                                    addressValue: park.address,
                                                    detectionValue: park.alertCount,
                                                    turbineValue: park.windmills.length,

                                                    park: (
                                                        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
                                                            {park.name}
                                                        </MDTypography>
                                                    ),
                                                    address: (
                                                        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
                                                            {park.address}
                                                        </MDTypography>
                                                    ),
                                                    detection: (
                                                        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
                                                            {park.alertCount}
                                                        </MDTypography>
                                                    ),
                                                    turbine: (
                                                        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
                                                            {park.windmills.length}
                                                        </MDTypography>
                                                    ),
                                                })),
                                            }}
                                            isSorted={false}
                                            entriesPerPage={false}
                                            showTotalEntries={false}
                                            noEndBorder
                                        />
                                    </MDBox>
                                </Card>
                            </Grid>
                        </Grid>
                    </>
                )}
            </MDBox>
        </TurbineDashboardLayout>
    );
}

export default MainParkList;


